<template>
  <div class="d-flex align-items-center">
    <div v-for="(item,index) in menu" :key="index" class="mx-2">
      <NavbarCustomOption v-if="item.type === 'option' && !!item.status" :cart="cart" :footer="footer" :item="item" :user="user" :publicUser="publicUser"/>
      <NavbarCustomGroup v-else-if="item.type === 'group' && !!item.status" :footer="footer" :group="item"/>
    </div>
  </div>
</template>

<script>
import NavbarCustomOption from './NavbarCustomOption'
import NavbarCustomGroup from './NavbarCustomGroup'

export default {
  name: "NavbarCustomMenu",
  components: {
    NavbarCustomOption,
    NavbarCustomGroup,
  },
  props: {
    menu: Object | Array,
    footer: Boolean,
    cart: {
      type: Number
    },
    user: {
      type: Object,
    },
    publicUser: {
      type: [Boolean, Number],
      require: true
    }
  },
  methods: {
    setTarget(target) {
      if (target) return "_blank";
    }
  },
  computed: {
    color() {
      return this.$store.getters.COLOR;
    }
  }
};
</script>

<style>
.nch--custom-menu {
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.5;
  padding: 0 !important;
}
.item{
  position: relative;
  padding: 10px 15px;
  display: block;
}
.hiddenList{
  position: absolute;
  top: 0;
  left: 100%;
  display: none;
  z-index: 10;
  min-width: 10rem;
  padding: 5px 10px;
  font-size: 1rem;
  color: #525f7f;
  text-align: left;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.15);
  border-radius: 0.4375rem;
  -webkit-box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}
.hiddenList.up{
  top: unset;
  bottom: 0
}
.hiddenList a{
  display: block;
  margin: 5px 0;
  width: 100%;
}
.item:hover .hiddenList{
  display: block;
}
.item:hover{
  background: rgba(0,0,0,.05);
}

.subgroup-label::after{
  display: inline-block;
  margin-left: 5px;
  content: "";
  border-left: 0.3em solid;
  border-top: 0.3em solid transparent;
  border-bottom: 0.3em solid transparent;
  border-right: 0em solid ;
}
</style>
